<template>
    <div class="main-content">

        <div class="row">

            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="filter_opt">
                                    <label for="">Дата</label>
                                    <datepicker v-model="filter.date" :language="ru" :monday-first="true"
                                                input-class="form-control"
                                                format="dd.MM.yyyy" placeholder="Дата"/>
                                </div>
                                <div class="filter_opt">
                                    <label for="">Номер заявки</label>
                                    <input type="number" v-model="filter.order_id" placeholder="Номер заявки" class="form-control">
                                    <p class="small_info">если указан номер заявки, то выбранная дата не учитывается в фильтрации</p>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="filter_opt">
                                    <label for="">Группа заявок</label>
                                    <select class="form-control" v-model="filter.message_group">
                                        <option value="0">Все группы</option>
                                        <option v-for="(group, index) in groups" :value="index">{{group}}</option>
                                    </select>
                                </div>
                                <div class="filter_opt">
                                    <label for="">Тип сообщения</label>
                                    <select class="form-control" v-model="filter.message_type">
                                        <option value="0">Все типы</option>
                                        <option v-for="(type, index) in types" :value="index">{{type}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="filter_opt">
                                    <label for="">Проекты</label>
                                    <select disabled class="form-control" v-model="filter.project">
                                        <option value="0">Все проекты</option>
                                        <option v-for="(type, index) in projects" :value="index">{{type}}</option>
                                    </select>
                                </div>
                                <div class="filter_opt">
                                    <label for="">Номер телефона</label>
                                    <input type="number" v-model="filter.phone" placeholder="Номер телефона" class="form-control">
                                </div>
                                <div class="text-right filter_btn">
                                    <button @click="filterSms" class="btn btn-info" type="button">Показать</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12">
                <pulse-loader :loading="loading" :color="color" class="text-center"/>
            </div>

            <div class="col-md-12" v-if="!loading">
                <div class="card">
                    <div class="card-body">

                        <div v-if="!records || !records.length" class="text-center">
                            <h5>Записей не найдено</h5>
                        </div>

                        <table v-if="records && records.length" class="table table-hover">
                            <thead>
                            <tr>
                                <th>ID</th>
                                <th>API ID</th>
                                <th>Заявка ID</th>
                                <th>Группа</th>
                                <th>Тип</th>
                                <th>Номер</th>
                                <th>Статус</th>
                                <th>SMS</th>
                                <th>Руб</th>
                                <th>System</th>
                                <th>Отправлено</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(record, index) in records" :key="index">
                                <td>{{record.id}}</td>
                                <td>{{record.api_message_id}}</td>
                                <td>{{record.order_id}}</td>
                                <td>{{groups[record.message_group_id]}}</td>
                                <td>{{types[record.message_type_id]}}</td>
                                <td>{{record.phone_number}}</td>
                                <td>{{statuses[record.status]}}</td>
                                <td>{{record.sms_body}}</td>
                                <td>{{record.price}}</td>
                                <td>{{record.system_info}}</td>
                                <td>{{record.created_at}}</td>
                            </tr>
                            </tbody>
                        </table>

                        <div class="table_bottom">
                            <div>
                                Всего записей: <strong>{{paginator.total}}</strong> <span v-if="sum">На сумму: <strong>{{sum}}</strong></span>
                            </div>
                            <div>
                                <paginate ref="paginationRecords" v-if="paginator"
                                          v-model="currentPage"
                                          :page-count="paginator.last_page"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="filterSms"
                                          :prev-text="'&laquo'"
                                          :next-text="'&raquo'"
                                          :container-class="'pagination'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'"
                                          :active-class="'active green_btn'">
                                </paginate>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import api from '@/api'
    import Paginate from 'vuejs-paginate'
    import Datepicker from 'vuejs-datepicker'
    import {en, ru} from 'vuejs-datepicker/dist/locale'

    export default {
        components: {
            Paginate,
            Datepicker
        },
        data() {
            return {
                filter: {
                    message_group: 0,
                    message_type: 0,
                    project: 0,
                    order_id: null,
                    date: null,
                    phone: null,
                },
                currentPage: 1,
                ru: ru,
                date: null,
                paginator: null,
                loading: true,
                color: '#007dcc',
                records: null,
                types: null,
                groups: null,
                statuses: null,
                projects: null,
                sum: null,
                sms: {
                    receiver: null,
                    body: null
                }
            }
        },
        mounted() {
            this.getSendedSMS();
        },
        methods: {
            async filterSms(page = null) {
                this.loading = true;
                let {data: r_data} = await api.post('/sms/getSendedSMS?page=' + page, {
                    filter: this.filter
                });
                const {data, ...pagination} = r_data.records;
                this.paginator = pagination;
                this.records = data;
                this.currentPage = this.paginator.current_page;
                this.sum = r_data.sum;
                this.loading = false;
            },
            async getSendedSMS(page = null) {
                let {data: r_data} = await api.index('/sms/getSendedSMS?page=' + page);
                const {data, ...pagination} = r_data.records;
                this.paginator = pagination;
                this.records = data;
                this.types = r_data.types;
                this.projects = r_data.projects;
                this.groups = r_data.groups;
                this.statuses = r_data.statuses;
                this.loading = false;
            },
            async sendSMS(e) {
                // console.log(e);
                let {data} = await api.store('/sms/sendSMS', {
                    data: this.sms
                });
            },
        }
    }

</script>

<style scoped>
    .table_bottom{
        display: flex;
        justify-content: space-between;
    }
    .filter_opt {
        padding-bottom: 10px;
    }

    .small_info {
        font-size: 12px;
        color: darkgray;
    }

    .filter_btn {
        display: flex;
        justify-content: flex-end;
    }

    .filter_btn button {
        align-self: flex-end;
    }
</style>

<style>
    .pagination {
        justify-content: flex-end;
    }
</style>
